/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Blank_Empty_TitleInputs */

const en_us2_workout_blank_empty_title = /** @type {(inputs: Workout_Blank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your first exercise`)
};

const pt_br2_workout_blank_empty_title = /** @type {(inputs: Workout_Blank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha o primeiro exercício`)
};

const es_419_workout_blank_empty_title = /** @type {(inputs: Workout_Blank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige tu primer ejercicio`)
};

const pt_pt2_workout_blank_empty_title = /** @type {(inputs: Workout_Blank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe o primeiro exercício`)
};

const fr_fr2_workout_blank_empty_title = /** @type {(inputs: Workout_Blank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis ton premier exercice`)
};

const de_de2_workout_blank_empty_title = /** @type {(inputs: Workout_Blank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl deine erste Übung`)
};

const it_it2_workout_blank_empty_title = /** @type {(inputs: Workout_Blank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli il primo esercizio`)
};

/**
* | output |
* | --- |
* | "Choose your first exercise" |
*
* @param {Workout_Blank_Empty_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_blank_empty_title = /** @type {((inputs?: Workout_Blank_Empty_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Blank_Empty_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_blank_empty_title(inputs)
	if (locale === "es-419") return es_419_workout_blank_empty_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_blank_empty_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_blank_empty_title(inputs)
	if (locale === "de-DE") return de_de2_workout_blank_empty_title(inputs)
	if (locale === "it-IT") return it_it2_workout_blank_empty_title(inputs)
	return en_us2_workout_blank_empty_title(inputs)
});
export { workout_blank_empty_title as "workout.blank_empty_title" }